import {Component, useState} from "react";
import React from "react";
import axios from "axios";
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import {toast} from "react-toastify";
import Select from 'react-select'


const assignmentOptions = [
    { value: 'Choose One', label: 'Choose One' },
    { value: 'Account', label: 'Account' },
    { value: 'Terminal', label: 'Terminal' }

]


export default class Assignment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loggedInUser: null,
            accountLHSView: [],
            accountRHSView: [],
            terminalLHSView: [],
            terminalRHSView: [],
            accountLHSListDual:[],
            accountRHSListDual:[],
            terminalLHSListDual:[],
            terminalRHSListDual:[],
            selectedAccountList: [],
            selectedTerminalList: [],
            accessForType:'',
            userid: 'Administrator',
            selectedList: [],
            prevUser: '',
            selection: '',
            selectedUniqueAccountList:[],
            selectedAccount:'',
        };
        this.baseState = this.state



    }


    resetForm = () => {
        this.setState(this.baseState)
        this.setState({selectedList: ['']})
        this.setState({accountLHSListDual:['']})
        this.setState({terminalLHSListDual:['']})
        this.setState({accountRHSListDual:['']})
        this.setState({terminalRHSListDual:['']})
    }




    onChange = (selectedList, selection) => {
        this.setState({ selectedList });
    };


    componentDidUpdate(prevProps, prevState) {

        if (typeof this.props.data.data !== 'undefined'){
           // console.log(this.state.userid," ====1====",this.props.data.data.clickedUserId, " =====1=====",this.state.loggedInUser)
            if(this.state.userid != this.props.data.data.clickedUserId && ((this.state.userid !=this.state.loggedInUser))) {
                this.setState({accountLHSListDual:['']});
                this.setState({terminalLHSListDual:['']});
                this.setState({selection: ''});
                console.log(" TRIGGER RESET DROP DOWN",)
            }
        }
        if (typeof this.props.data.data !== 'undefined'){
            this.state.userid=this.props.data.data.clickedUserId
        }
    }



    componentDidMount() {

        this.resetForm();
        if (typeof this.props.data.data !== 'undefined'){
            this.state.userid=this.props.data.data.clickedUserId
        }
        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {
                this.setState({
                    assignmentOptions: assignmentOptions
                });
                    this.setState({loggedInUser: response.data})
            }).catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });
    }



    handleChange = (event) => {
        this.setState({ selection: event.value });

        //reset state after drop down changes
        this.setState({ accessForType: event.value });
        this.setState({selectedList: ['']})
        this.setState({accountLHSListDual:['']})
        this.setState({terminalLHSListDual:['']})
        //End of State change
        if(event.value === 'Account') {
           // this.setState({selectedAccount: [this.props.data.data.clickedUserId]});
            console.log("----- this?.state?.selectedAccount",this?.state?.selectedAccount)
            axios.get('getAccountLHSViewList?id=' + this.props.data.data.clickedUserId+'&parentUserId='+this.state.loggedInUser, {
                headers: {"Access-Control-Allow-Origin": "*"}
            })
                .then(response => {
                    this.setState({accountLHSView: response.data.response, loading: false})
                }).catch(error => {
                    console.log("Exception Thrown::{getAccountLHSViewList}", error);
                }).finally(()=> {
                this.accountLHSListDual = this.state.accountLHSView.map(feature => (
                    { value: feature.destCode, label: feature.destDescription }
                ));

                //Retrieve Account RHS after LHS has been retrieved
                axios.get('getAccountRHSViewList?id=' + this.props.data.data.clickedUserId+'&parentUserId='+this.state.loggedInUser, {
                    headers: {"Access-Control-Allow-Origin": "*"}
                })
                    .then(response => {
                        this.setState({accountRHSView: response.data.response, loading: false})
                        this.accountRHSView = response.data.response;

                    }).catch(error => {
                    console.log("Exception Thrown::{getAccountRHSViewList}", error);
                }).finally(()=> {
                    let rhsElements = [];

                    for (const element of this.accountRHSView) {
                        rhsElements.push(element.destCode)
                    }
                    //this.setState({selectedList: rhsElements})
                    this.setState({selectedList: rhsElements})
                    this.accountRHSView.map(feature => (
                        this.accountLHSListDual.push( { value: feature.destCode, label: feature.destDescription })
                    ))
                    this.setState({selectedList: rhsElements})
                    this.setState({accountLHSListDual:this.accountLHSListDual})
                    //console.log("Account ----- ", this.accountLHSListDual,' ----- ',this.state.selectedList.length)

                });

                this.setState({accountLHSListDual:this.accountLHSListDual})

            })
        }else {
            axios.get('getTerminalLHSViewList?id=' + this.props.data.data.clickedUserId+'&parentUserId='+this.state.loggedInUser, {
                headers: {"Access-Control-Allow-Origin": "*"}
            }).then(response => {
                this.setState({terminalLHSView: response.data.response, loading: false})
                this.terminalLHSListDual = this.state.terminalLHSView.map(feature => (
                    { value: feature.terminalID, label: feature.terminalID+" "+feature.locationName}
                ));
                this.setState({terminalLHSListDual:this.terminalLHSListDual})
                //Retrieve Terminal RHS after LHS has been retrieved
                axios.get('getTerminalRHSViewList?id=' + this.props.data.data.clickedUserId+'&parentUserId='+this.state.loggedInUser, {
                    headers: {"Access-Control-Allow-Origin": "*"}
                }).then(response => {
                    this.setState({terminalRHSView: response.data.response, loading: false})
                    this.terminalRHSView = response.data.response;
                    let rhsTerminalElements = [];
                    for (const element of this.terminalRHSView) {
                        rhsTerminalElements.push(element.terminalID)
                    }
                    this.setState({selectedList: rhsTerminalElements})
                    if (typeof this.terminalRHSView !== 'undefined'){
                        this.terminalRHSView.map(feature => (
                            this.terminalLHSListDual.push( { value: feature.terminalID, label: feature.terminalID+" "+feature.locationName })
                        ))
                    }
                    this.setState({terminalLHSListDual:this.terminalLHSListDual})
                }).catch(error => {
                    console.log("GOT ERROR HERE for getTerminalRHSViewList", error);
                });
            }).catch(error => {
                console.log("GOT ERROR HERE for getTerminalLHSViewList", error);
            });

        }

        let accountRHSListDual,selectedAccountList;
        let terminalLHSListDual,selectedTerminalList;
        const { accountLHSView, accountRHSView ,selectedList} = this.state;


        ///Start of dual list view Tab
        this.accountLHSListDual = this.state.accountLHSView.map(feature => (
            { value: feature.destCode, label: feature.destDescription }
        ));

        if (typeof this.accountRHSView !== 'undefined'){
            this.accountRHSView.map(feature => (
                this.accountLHSListDual.push( { value: feature.destCode, label: feature.destDescription })
            ))
        }
        this.setState({accountLHSListDual:this.accountLHSListDual})

        ///Start of dual list view Tab
        this.terminalLHSListDual = this.state.terminalLHSView.map(feature => (
            { value: feature.terminalID, label: feature.terminalID+" "+feature.locationName }
        ));
        if (typeof this.terminalRHSView !== 'undefined'){
            this.terminalRHSView.map(feature => (
                this.terminalLHSListDual.push( { value: feature.terminalID, label: feature.terminalID+" "+feature.locationName })
            ))
        }
        this.setState({terminalLHSListDual:this.terminalLHSListDual})
        ////////////////////////////
    };

    handleSubmit = event => {
        event.preventDefault();
        const assignmentList ={
            selectedList: this.state.selectedList,
            selectedAccess: this.state.accessForType,
            currentUserID: this.state.loggedInUser,
            currentSourceUserId: this.props.data.data.clickedUserId
        };

            axios.post(`updateAssignment`, assignmentList)
                .then(res => {
                    toast.success('Assignment Updated Successfully !!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                    alert("Assignment Updated Successfully !!")
                    console.log(res);
                }).catch(error => {
                toast.error("Assignment Updation Failed,Please try again !!", {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                alert("Assignment Updation Failed,Please try again !!")
                console.log("=== LOG_Error === Inside try catch %s with data ","Update Assignment",error);
            });

    }


    render() {

        const forUsersOptions = [
            { value: this.state.loggedInUser, label: this.state.loggedInUser }
        ]
       const selectedAccountDefault = [ {label: this.state.selectedAccount, value: this.state.selectedAccount}
        ]

        const selectUserDiv = <div className="tab-pane" id="tb_assignment" role="tabpanel">
            <h5 className="tbsub-title mt-3 mb-3"> Please Select User for Assignments Below...</h5></div>
        const assingmentDiv = <div className="tab-pane" id="tb_assignment" role="tabpanel">
                <h5 className="tbsub-title mt-3 mb-3">Assignments</h5>
                <form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Grant Access for <strong style={{color:'#002170'}}>{this.state.selection}</strong></label>
                               <Select options={assignmentOptions} value={this.state.selection} onChange={this.handleChange}/>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">From User</label>
                                <Select value={selectedAccountDefault} options={forUsersOptions}/>
                            </div>
                        </div>
                    </div>
                    <h5 className="tbsub-title mt-3 mb-3">Explicit grant access to a subset of terminals
                        that {this.state.userid} has access to:</h5>
                    <div>
                        <DualListBox canFilter
                                     options={this.state.accessForType === 'Account' ? this.state.accountLHSListDual : this.state.terminalLHSListDual}
                                     selected={this.state.selectedList}
                                     filterPlaceholder={'Filter ' + this.state.accessForType}
                                     onChange={this.onChange}
                        />
                    </div>
                    <div className="row mt-5 justify-content-md-center">
                        <div className="col-md-4">
                            <button type="submit"
                                    className="btn btn-block btn-primary w-md">Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        if(this.state.userid === '' || (this.state.userid ===this.state.loggedInUser)) {
            return selectUserDiv;
        }else{
            return assingmentDiv;
        }
    }
}